import React, {useState, useEffect} from "react";
import {
  Page,
} from "components/common";
import { FormGroup, SaveButton } from "components/common/Forms";
import GetBack from "components/refactoring/BackButton";
import { LocalForm, Control, actions } from "react-redux-form";
import { Trans } from "react-i18next";
import { useHistory } from "react-router-dom";
import { Button, TabContent, Table, TabPane, Col, Row, NavLink, Nav, NavItem, Modal, ModalFooter, ModalHeader, ModalBody } from "reactstrap";
import { ApiClient } from "services";
import { Link } from "react-router-dom/cjs/react-router-dom.min";
import { formatDate, navTab } from "services/util";
import AccessPermissions from "pages/UserList/AccessPermissions";
import { NotificationManager } from "react-notifications";
import Select from "react-select";
import LoadingMsg from "components/common/LoadingMsg";

export const getOutlineStyle = (color, size) => ({
    border: `2px solid ${color}`,
    color: color,
    padding: '0.25rem 0.5rem',
    borderRadius: '0.2rem',
    fontSize: size
  });

export const CompanyDetail = ({
  t,
  history,
  match,
}) => {

    const client = ApiClient() 
    const classnames = (...classNames) => classNames.filter(Boolean).join(' ');


    const [comData, setcompanyData] = useState();
    const [loading, setLoading] = useState(false);

    const fetchData = async () => {
        setLoading(true)
        try {
          setLoading(true)
          const responseCom = await client.get(`core/company/${match.params.id}`);
          const comData = responseCom.data;
          setcompanyData(comData);
          setLoading(false)
        } catch (error) {
          console.error("Error fetching data:", error);
          setLoading(false)
        }
      };

    useEffect(() => {
      fetchData();
    }, []);

  const [isModalOpen, setisOpen] = useState(false);
  const [isViewMode, setViewMode] = useState(true);
  const [isSuperModal, setIsOpenSuper] = useState(false);
  const [userDetails, setDetails] = useState()
  const [isChanging, setIsChanging] = useState()

  
  const closeModal = () => {
      setisOpen(false);
      setIsOpenSuper(false)
  };
  
  const onUserClick =  async (details, superModal) => { 
      setDetails(details)
      if (superModal) {
        setIsOpenSuper(true)
      } else {
        setisOpen(true)
      }
  }

  const [activeTab, setActiveTab] = useState('1');

    const toggleTab = (tab) => {
        if (activeTab !== tab) setActiveTab(tab);
    };

const changeSubscriber = async (values) => {

    setIsChanging(true)

    NotificationManager.info("Changing the users Subscriber", userDetails.first_name)

    let postData = {
        ref_company_id: comData?.id,
        role: "Subscriber",
    }

    client.post(`/users/${userDetails.id}/organisation-enrollment`, postData)
        .then(response => {
            fetchData()
            setTimeout(() => {
            setIsChanging(false)
            NotificationManager.success(t("Company subscriber was changed successfully."));
            closeModal()
            }, 1000);
        })
        .catch(error => {
        console.error("Error:", error);
        setIsChanging(false);
        });
    }

    const subscriberUser = comData?.user?.find((i) => (i.role === "Subscriber"))

    const onEdit = async (values) => {

      let updatedValues = { ...values }; 

      if (values.organisations && values.user && values.id) {
          delete updatedValues.organisations;
          delete updatedValues.user;
          delete updatedValues.id;
      }

      setIsChanging(true)
  
      client.put(`/core/company/${match.params.id}`, updatedValues)
          .then(response => {
              setTimeout(() => {
              setIsChanging(false)
              fetchData()
              setViewMode(true)
              NotificationManager.success(t("Company details were changed successfully."));
              }, 1000);
          })
          .catch(error => {
          console.error("Error:", error);
          NotificationManager.error(t("Error Occured."));
          setIsChanging(false);
          });
      }

  return (
    <Page title={`Company Details`} className="inv-table inv-tabs nw-list">
        <GetBack styleClass="my-2"/>
        {loading && <LoadingMsg/>}
        {comData &&
        <> 
        <Button size="sm" className="float-right" onClick={() => setViewMode(!isViewMode)}><Trans>{isViewMode ? "Edit" : "View"}</Trans></Button>
        <Row className="pt-4">
          {isViewMode ?
          <>
            {/* <Col className="col-auto">
                <i width="500" className="fa fa-file lg"/>
            </Col> */}
            <Col md={10}>
                <h3 className="text-success">{comData.name}</h3>
                <Row>
                    <Col className="col-auto">
                        <h6><Trans>Email:</Trans> <span className="text-success">{comData.email}</span></h6>
                        <h6><Trans>Contact Number:</Trans> <span className="text-success">{comData.contact_number}</span></h6>
                        <h6><Trans>Country:</Trans> <span className="text-success">{comData.country}</span></h6>
                    </Col>
                    <Col className="col-auto">
                        <h6><Trans>Tax number:</Trans> <span className="text-success">{comData.tax_number}</span></h6>
                        <h6><Trans>Total Organisation:</Trans> <span className="text-success">{comData.organisations_count}</span></h6>
                    </Col>
                    
                </Row>
            </Col>
          </>
          :
          <Col>
          <LocalForm
            initialState={comData}
            onSubmit={onEdit}
          >
          <Row>
            <Col md={6}>
              <span style={{fontSize:"1.4em"}}><Trans>Company Name</Trans></span>
              <FormGroup model=".email">
                <Control.text model=".name" placeholder="A company name." />
              </FormGroup>
            </Col>
          </Row>
          <Row className="mt-3">
            <Col md={6}>
              <FormGroup label="Primary Email" model=".email">
                <Control.text model=".email" placeholder="Add contact email" />
              </FormGroup>
              <FormGroup label="Contact number" model=".contact_number">
                <Control.text model=".contact_number" placeholder="Add contact number" />
              </FormGroup>
            </Col>
            <Col md={6}>
              <FormGroup label="Country Code" model=".country">
                <Control.text model=".country" placeholder="Add country code" />
              </FormGroup>
              <FormGroup label="Tax number" model=".tax_number">
                <Control.text model=".tax_number" placeholder="Add tax number" />
              </FormGroup>
            </Col>
          </Row>
          <div className="mt-2">
            {isChanging ? 
              <Button size="sm" disabled className="m-0"><i className="fa fa-spin fa-spinner" /> <Trans>Updating</Trans></Button>
              : 
              <Button size="sm" className="m-0"><Trans>Update</Trans></Button>
            }
          </div>
          </LocalForm>
          </Col>  
          }
        </Row>
    <Row className="pt-4">
      <Col>
        <Nav tabs className="nw-tabs2 inv-tabs">
            <div style={{cursor:"pointer"}} onClick={() => toggleTab('1')} className={activeTab === '1' ? `active-tab`: ``}>
                <Trans>Organisation List</Trans> 
            </div>
            <div style={{cursor:"pointer"}} onClick={() => toggleTab('2')} className={activeTab === '2' ? `active-tab`: ``}>
                <Trans>Users List</Trans> 
            </div>
            {/* <NavItem>
                <NavLink className={classnames({ active: activeTab === '1' })} onClick={() => toggleTab('1')}>
                    <Trans>Organisation List</Trans>
                </NavLink>
            </NavItem>
            <NavItem>
                <NavLink className={classnames({ active: activeTab === '2' })} onClick={() => toggleTab('2')}>
                    <Trans>Users List</Trans>
                </NavLink>
            </NavItem> */}
        </Nav>
      </Col>
    </Row>
    <TabContent activeTab={activeTab}>
     <TabPane tabId="1">
        <Row>
            <Col>
                <h4 className="pt-3">Organisation List</h4>
                <Table size="" className="">
                    <thead>
                        <tr>
                            <th sortBy="name" className="text-left">
                                <Trans>Name</Trans>
                            </th>
                            <th sortBy="subscriber_user">
                                <Trans>Subscriber User</Trans>
                            </th>
                            <th sortBy="subscription_plan">
                                <Trans>Subscription Plan</Trans>
                            </th>
                            <th sortBy="">
                                <Trans>Subscription Date</Trans>
                            </th>
                            <th sortBy="">
                                <Trans>Expiration Date</Trans>
                            </th>
                            <th sortBy="">
                                <Trans>Next Billing Date</Trans>
                            </th>
                            <th sortBy="id">
                                <Trans>Subscrition Status</Trans>
                            </th>
                            {/* <th sortBy="status">
                                <Trans>Xero Conection</Trans>
                            </th>
                            <th></th> */}
                            <th/>
                        </tr>
                    </thead>
                    <tbody>
                        {comData?.organisations?.map((i) => (
                        
                        <tr key={i.id}>
                            
                            <td className="text-left"><Link to={`/core/organisation/${i.id}`}>{i.name}</Link></td>
                            <td>{i.subscriber_user}</td>
                            <td>{i.subscription_detail?.current_subscription?.subscription_plan_name}</td>
                            <td>{i.subscription_detail?.current_subscription?.start_date}</td>
                            <td>{i.subscription_detail?.current_subscription?.end_date}</td>
                            <td>{i.subscription_detail?.current_subscription?.next_invoice_date}</td>
                            <td style={{ 
                                color: i.subscription_detail?.current_subscription?.status === 'Active' ? '#72B566' :
                                i.subscription_detail?.current_subscription?.status === 'Inactive' ? '#E64848' :'#ffc107'
                            }}>
                                <strong>{i.subscription_detail?.current_subscription?.status || "N/A"}</strong>
                            </td>
                            {/* <td style={{ color: 
                                i.status === 'LIVE' ? 'green' :
                                i.status === 'NOT_CONNECTED' ? 'red' :
                                'orange',
                            }}>
                            <strong>{
                                i.status === 'LIVE' ? 'LIVE' :
                                i.status === 'NOT_CONNECTED' ? 'DISCONNECTED' :
                                'EXPIRED'
                            }</strong>
                            </td> */}
                            <td>
                                <Button onClick={() => history.push(`/core/organisation/${i.id}`)} color="primary" size="sm"><i className="fa fa-edit"/></Button>
                            </td>
                        </tr>
                        
                        ))}
                    </tbody>
                </Table>
            </Col>
        </Row>
      </TabPane>
    </TabContent>
    <TabContent activeTab={activeTab}>
     <TabPane tabId="2">
     <Row>
                            <Col>
                                <h4 className="pt-4">User List</h4>
                                <Table size="sm" className="small">
                                    <thead>
                                        <tr>
                                            <th className="text-left"><Trans>ID </Trans></th>
                                            <th><Trans>Name</Trans></th>
                                            <th><Trans>Email</Trans></th>
                                            <th><Trans>Role</Trans></th>
                                            <th><Trans>Group</Trans></th>
                                            <th><Trans>Active</Trans></th>
                                            <th><Trans>Joined</Trans></th>
                                            <th className="text-right"><Trans>Last Login</Trans></th>
                                            <th/>
                                            <th/>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {comData?.user?.map((i) => (
                                        <tr key={i.id}>
                                            <td className="text-left">{i.id}</td>
                                            <td><Link to={`/${i.role === "Subscriber" ? "subscribers" : "users"}/${i.id}`}>{i.full_name}</Link></td>
                                            <td>{i.email}</td>
                                            <td>{i.role === "Subscriber" ? 
                                                <span className="ml-2" style={getOutlineStyle('#72B566')}>{i.role}</span> :
                                                <Button disabled={i.group_names[0] !=="Superadmin"} color="secondary" outline={true} size="sm" onClick={() => onUserClick(i, true)}><Trans>{i.role}</Trans></Button>}</td>
                                            <td>{i.group_names}</td>
                                            <td>
                                            {i.is_active ? (
                                                    <span className="fa fa-check-circle text-success" />
                                                ) : (
                                                    <span className="fa fa-times-circle text-danger" />
                                                )}
                                            </td>
                                            <td>{formatDate(i.date_joined)}</td>
                                            <td>{formatDate(i.last_login)}</td>
                                            <td> 
                                                <button
                                                    className="btn btn-secondary btn-sm"
                                                    onClick={() => onUserClick(i, false)}>
                                                    <Trans>Access</Trans>
                                                    </button>
                                                    </td>   
                                        </tr>
                                        ))}
                                    </tbody>
                                </Table>
                            </Col>
                        </Row>
     </TabPane>
     </TabContent>
     {userDetails && <AccessPermissions show={isModalOpen} handleClose={closeModal} org={comData?.organisations} userID={userDetails.id} details={userDetails}/>}
     <Modal isOpen={isSuperModal} toggle={closeModal}>
          <LocalForm onSubmit={changeSubscriber}>
            <ModalHeader>
              <div><Trans>Subscriber Details</Trans></div>
            </ModalHeader>
            <ModalBody className="mb-1" style={{overflowY: 'visible'}}>
              <div>
                <span><Trans>You are changing the Subscriber of the Company</Trans></span>
              </div>
              <Row className="mt-2">
                <Col>
                  <FormGroup className="my-2" label="Company Name">
                    <Control.text model=".company_name" defaultValue={comData?.name} disabled/>
                  </FormGroup>
                  <Row>
                    <Col>
                  <FormGroup className="my-2" label="Old Subscriber">
                    <Control.text model=".subscriberUser_name" defaultValue={subscriberUser?.full_name} disabled/>
                  </FormGroup>
                  <FormGroup className="my-2" label="Old Subscriber Email">
                    <Control.text model=".subscriberUser_email" defaultValue={subscriberUser?.email} disabled/>
                  </FormGroup>
                  </Col>
                  <Col>
                  <FormGroup className="my-2" label="New Subscriber">
                    <Control.text model=".user_name" defaultValue={userDetails?.full_name} disabled/>
                  </FormGroup>
                  <FormGroup className="my-2" label="New Subscriber Email">
                    <Control.text model=".user_email" defaultValue={userDetails?.email} disabled/>
                  </FormGroup>
                  </Col>
                  </Row>
                </Col>
              </Row>
              <div style={{fontSize:"1.2em"}} className="text-muted my-2 text-center"><span><Trans>Are you sure you want to continue?</Trans></span></div>
            </ModalBody>
            <ModalFooter>
              {!isChanging ?
                <Button color="success"><Trans>Assign</Trans></Button>
                :
                <Button color="success" disabled><i className="fa fa-spin fa-spinner"/> <Trans>Assigning</Trans></Button>
              }
              <Button onClick={closeModal}>Close</Button>
            </ModalFooter>
          </LocalForm>
        </Modal>
        </>
        }
    </Page>
  );
};

export default CompanyDetail;
